import React, { useContext, useLayoutEffect, useState, useEffect } from "react";
import { filter } from "rxjs/operators";
import { Subject } from "rxjs";

import { TableContext } from "./TableContext";
import { IAction } from "./interfaces";

type Props = {
  dispatch: (action: IAction) => void;
  action: IAction;
};

export const OnActionChanged: React.FC<{
  children: (props: Props) => void;
  actionFilter: (action: IAction) => boolean;
}> = ({ children, actionFilter }) => {
  const { subscribeAction, dispatch } = useContext(TableContext);
  const [action, setAction] = useState<IAction | null>(null);

  useLayoutEffect(() => {
    const tableAction$ = new Subject<IAction>();
    const detailSubscription = tableAction$
      .pipe(filter(actionFilter))
      .subscribe(targetAction => {
        setAction(targetAction);
      });

    const subscription = subscribeAction(tableAction$);

    return () => {
      tableAction$.complete();
      subscription.unsubscribe();
      detailSubscription.unsubscribe();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (action) {
      children({ dispatch, action });
    }
  });

  return null;
};
